// ═══════════════════════════════════════════════════════════════
// TwaContext.jsx — React context wrapper for TWA detection
//
// Tests override by wrapping in <TwaProvider value={true|false}>.
// Production renders <TwaProvider> with no value so it reads from
// the twa.js module helper.
// ═══════════════════════════════════════════════════════════════

import React, { createContext, useContext } from 'react';
import { isAndroidWrapper } from './twa.js';

const TwaContext = createContext(null);

function TwaProvider({ value, children }) {
  const flag = value != null ? value : isAndroidWrapper();
  return <TwaContext.Provider value={flag}>{children}</TwaContext.Provider>;
}

function useIsAndroidWrapper() {
  const ctx = useContext(TwaContext);
  return ctx != null ? ctx : isAndroidWrapper();
}

// Combines TWA detection with the admin/support exemption:
// returns true only when the gate should apply to this user.
// Admin/support roles use the Stripe portal for tenant management —
// not a "consumer purchase" under Google's policy.
function useIsTwaSubscriptionGated(user) {
  const inTwa = useIsAndroidWrapper();
  if (!inTwa) return false;
  if (!user) return true;
  if (user.role === 'admin' || user.role === 'support') return false;
  return true;
}

export { TwaProvider, useIsAndroidWrapper, useIsTwaSubscriptionGated };
